import {combineReducers} from 'redux';
import todos from './todos';

export const reducers = combineReducers({ todos });